import { MESSAGE_INBOUND } from '@/app/module/logs/definitions'
import { DirectionType, MessageType, SMSLog, WhatsAppLog } from '@/app/types/log'

type ConversationSMSStatusFields = {
  direction: DirectionType
  done: boolean
  error?: SMSLog['error']
}
type SMSStatusFields = {
  deliveredToPhone?: SMSLog['deliveredToPhone']
  deliveredToTelco?: SMSLog['deliveredToTelco']
  direction: DirectionType
  done: boolean
}
type WhatsAppStatusFields = Pick<WhatsAppLog, 'deliveredToPhone' | 'direction' | 'done' | 'error' | 'read'>
export type SMSMessageStatus = 'Received' | 'Delivered' | 'Sent' | 'Pending' | 'Failed'

export const isInboundMessage = ({ direction }: { direction: string }) => direction === MESSAGE_INBOUND

export const getSMSMessageStatus = (item: SMSStatusFields): SMSMessageStatus => {
  const { deliveredToPhone, deliveredToTelco, done } = item
  if (isInboundMessage(item)) return 'Received'
  if (done) {
    if (deliveredToTelco === false || deliveredToPhone === 'failed') return 'Failed'
    if (deliveredToPhone === 'confirmed') return 'Delivered'
    return 'Sent'
  }
  return 'Pending'
}

export const getConversationSMSMessageStatus = ({ direction, done, error }: ConversationSMSStatusFields): string => {
  if (direction === MESSAGE_INBOUND) {
    return ''
  }
  if (done) {
    return 'Delivered'
  }
  return error ? `Failed: ${error}` : 'Failed'
}

export const getWhatsAppMessageStatus = ({
  deliveredToPhone,
  direction,
  done,
  error,
  read,
}: WhatsAppStatusFields): string => {
  if (direction === MESSAGE_INBOUND) {
    if (done) {
      return 'Received'
    }
    return 'Not received'
  }

  if (read) {
    return 'Read'
  }
  if (deliveredToPhone === 'in progress') {
    return 'In Progress'
  }
  if (deliveredToPhone === 'sent') {
    return 'Sent'
  }
  if (deliveredToPhone === 'confirmed') {
    return 'Delivered'
  }
  if (deliveredToPhone === 'failed') {
    return error ? `Not Delivered ${error}` : 'Not Delivered'
  }
  if (done) {
    return 'Sent'
  }
  return error ? `Not Sent ${error}` : 'Not Sent'
}

export const getConversationMessageStatus = (part: SMSLog | WhatsAppLog): string => {
  if (part.type === MessageType.WhatsApp) {
    return getWhatsAppMessageStatus(part)
  }

  if (part.type === MessageType.SMS) {
    return getConversationSMSMessageStatus(part)
  }

  return ''
}
